export function getApiErrorMessage(error, fallback) {
  const data = error?.response?.data;
  const raw = data?.error || data?.message || error?.message || '';
  const status = error?.response?.status;

  if (status === 401) return 'Session expirée ou identifiants invalides (401). Veuillez vous reconnecter.';
  if (status === 403) return 'Accès refusé (403). Contactez un administrateur si vous pensez que c’est une erreur.';
  if (status === 404) return 'Ressource introuvable (404). Vérifiez que vous utilisez le bon écran/URL.';
  if (status >= 500) return raw ? String(raw) : 'Erreur serveur (5xx). Réessayez dans quelques instants, puis contactez le support si le problème persiste.';

  if (raw === 'Network Error') return 'Impossible de contacter le serveur. Vérifiez votre connexion et que le backend est démarré.';

  if (raw === 'Room is full') return 'Chambre pleine (capacité atteinte). Choisissez une autre chambre ou augmentez la capacité.';
  if (raw === 'Room has active assignments') return 'Impossible: chambre occupée (affectations actives). Retirez d’abord les occupants ou choisissez une autre chambre.';
  if (raw === 'Capacity is below active occupants') return 'Capacité invalide: inférieure au nombre d’occupants actifs. Augmentez la capacité ou libérez des places.';

  if (raw) return String(raw);
  return fallback || 'Une erreur est survenue.';
}
